import { WORK_TYPES } from './constants'
import { v4 as uuidv4 } from 'uuid'
import { utcDate } from 'utils/helpers'

export const toResult = weekReport => {
  return weekReport.map(row => {
    return {
      id: uuidv4(),
      deal: {
        value: row.key.dealId,
        label: row.key.dealName
      },
      clients: [],
      client: row.key.clientId
        ? {
            value: row.key.clientId,
            label: row.key.client
          }
        : null,
      service: row.key.serviceId
        ? {
            value: row.key.serviceId,
            label: row.key.service
          }
        : null,
      workType: WORK_TYPES.find(w => w.value === row.key.workType),
      hours: row.hours,
      readOnly: true,
      billable: row.key.isBillable,
      notes: row.notes
    }
  })
}

export const toOptions = (options, props = {}) => {
  return options.map(o => {
    return {
      value: o.id,
      label: o.name,
      ...props
    }
  })
}

export const fromResult = (weekReport, selectedWeek, userId) => {
  const entries = weekReport.map(row => {
    return {
      hours: row.hours,
      typeOfWorkId: row.service.value,
      isTimeOff: row.service.isTimeOff,
      dealId: row.deal?.value ?? null,
      billable: row.billable,
      workTimeType: row.workType?.value ?? null,
      notes: row.notes,
      clientId: row.client?.value ?? null
    }
  })

  return {
    entries,
    userId,
    from: utcDate(selectedWeek[0])
  }
}
